import React from 'react';
import Appbar from 'components/appbar/Appbar';
import DoctorListTable from './list/table/DoctorListTable';
import DoctorListModule from './list/module/DoctorListModule';
import DoctorAction from './DoctorAction';
import PageHeaderActions from 'components/page-header/PageHeaderActions';
import NewRecordButton from 'components/page-header/NewRecordButton';
import PaginationProvider from 'hooks/pagination';
import Pagination from 'components/pagination/Pagination';
import DoctorFilterBox from './DoctorFilterBox';
import { useFetchDoctors } from './hooks/useFetchDoctors';
import { useDisplayMode } from 'hooks/useDisplayMode';
import NoData from 'components/no-data/NoData';
import TableLoading from 'components/loading/TableLoading';
import ModuleLoading from 'components/loading/ModuleLoading';

const Doctor: React.FC = () => {
  const {
    doctors,
    filter,
    loading,
    orderedIndex,
    handleSearch,
    handleSort,
    handleChange,
    setPage,
    setRows,
    page,
    rows,
    total,
  } = useFetchDoctors();
  const [displayMode] = useDisplayMode();

  return (
    <>
      <Appbar title="Médicos" ActionsComponent={<DoctorAction />} />
      <PageHeaderActions
        title="Médicos"
        description="Gestão de médicos da clínica"
        ActionComponent={<NewRecordButton label="Novo médico" to="/doctors/new" />}
      />

      <DoctorFilterBox loading={loading} handleChange={handleChange} filter={filter} handleSearch={handleSearch} />

      <PaginationProvider rowsPerPage={rows}>
        {loading ? (
          displayMode === 'list' ? (
            <TableLoading />
          ) : (
            <ModuleLoading />
          )
        ) : doctors.length === 0 ? (
          <NoData message="Nenhum médico encontrado" />
        ) : (
          <>
            {displayMode === 'list' ? <DoctorListTable doctors={doctors} /> : <DoctorListModule doctors={doctors} />}

            <Pagination
              count={total}
              currentPage={page}
              currentRowsPerPage={rows}
              onChangePage={page => setPage(page)}
              onChangeRowsPerPage={rows => setRows(rows)}
            />
          </>
        )}
      </PaginationProvider>
    </>
  );
};

export default Doctor;
